// @flow
import _ from 'lodash';
import { Map, List } from 'immutable';

import {
  BOOKING_STATE_UNKNOWN,
  BOOKING_STATE_NEW,
  BOOKING_STATE_SURFACED,
  BOOKING_STATE_BID,
  BOOKING_STATE_DECLINED,
  BOOKING_STATE_UNREAD,
  BOOKING_STATE_IGNORED,
  BOOKING_STATE_CONFIRMED,
  BOOKING_STATE_AWARDED,
  BOOKING_STATE_ADVANCE_AWARDED,
  BOOKING_STATE_PICKING_UP,
  BOOKING_STATE_DROPPING_OFF,
  BOOKING_STATE_RECYCLE,
  bookingStateMapping,
} from 'types/bookings';

import type { BookingRequestV2, BookingRequest, Booking } from 'types/bookings';

export function bookingStateString(bookingState: ?number) {
  if (typeof bookingState === 'number' && bookingState > 0) {
    return bookingStateMapping[bookingState];
  }
  return bookingStateMapping[BOOKING_STATE_UNKNOWN];
}

export function canBookingBeBid(state: number) {
  // TODO: Check which booking states can be bid for.
  const BIDDABLE_BOOKING_STATES = [
    BOOKING_STATE_UNKNOWN,
    BOOKING_STATE_NEW,
    BOOKING_STATE_SURFACED,
    BOOKING_STATE_RECYCLE,
  ];
  return _.includes(BIDDABLE_BOOKING_STATES, state);
}

export function canBookingBeCancelledByPassenger(state: number) {
  const PASSENGER_CANCELLABLE_BOOKING_STATES = [
    BOOKING_STATE_UNKNOWN,
    BOOKING_STATE_NEW,
    BOOKING_STATE_SURFACED,
    BOOKING_STATE_BID,
    BOOKING_STATE_DECLINED,
    BOOKING_STATE_UNREAD,
    BOOKING_STATE_IGNORED,
    BOOKING_STATE_CONFIRMED,
    BOOKING_STATE_AWARDED,
    BOOKING_STATE_ADVANCE_AWARDED,
    BOOKING_STATE_PICKING_UP,
    BOOKING_STATE_RECYCLE,
  ];
  return _.includes(PASSENGER_CANCELLABLE_BOOKING_STATES, state);
}

export function canBookingBeCancelledByDriver(state: number) {
  const DRIVER_CANCELLABLE_BOOKING_STATES = [
    BOOKING_STATE_CONFIRMED,
    BOOKING_STATE_AWARDED,
    BOOKING_STATE_ADVANCE_AWARDED,
    BOOKING_STATE_PICKING_UP,
  ];
  return _.includes(DRIVER_CANCELLABLE_BOOKING_STATES, state);
}

export function canBookingBePickedUp(state: number) {
  // TODO: Check which booking states can be picked up.
  const PICKUPABLE_BOOKING_STATES = [
    BOOKING_STATE_PICKING_UP,
  ];
  return _.includes(PICKUPABLE_BOOKING_STATES, state);
}

export function canBookingBeDroppedOff(state: number) {
  // TODO: Check which booking states can be dropped off.
  const DROPOFFABLE_BOOKING_STATES = [
    BOOKING_STATE_DROPPING_OFF,
  ];
  return _.includes(DROPOFFABLE_BOOKING_STATES, state);
}

export function toBookingRequestV2(bookingRequest: BookingRequest, pois: Map): BookingRequestV2 {
  const pickupLocationKey =
    List([bookingRequest.pickUpLongitude, bookingRequest.pickUpLatitude]);

  const itinerary = [{
    latitude: bookingRequest.pickUpLatitude,
    longitude: bookingRequest.pickUpLongitude,
    address: pois.get(pickupLocationKey) || '',
    keywords: pois.get(pickupLocationKey) || '',
  }];

  _.each(bookingRequest.extraDropOffs, (drop) => {
    if (!_.isEmpty(drop)) {
      const extraDropKey = List(drop);
      itinerary.push({
        latitude: drop[1],
        longitude: drop[0],
        address: pois.get(extraDropKey) || '',
        keywords: pois.get(extraDropKey) || '',
      });
    }
  });

  const dropOffLocationKey =
    List([bookingRequest.dropOffLongitude, bookingRequest.dropOffLatitude]);

  itinerary.push({
    latitude: bookingRequest.dropOffLatitude,
    longitude: bookingRequest.dropOffLongitude,
    address: pois.get(dropOffLocationKey) || '',
    keywords: pois.get(dropOffLocationKey) || '',
  });

  return {
    taxiTypeID: bookingRequest.taxiTypeID,
    paymentType: bookingRequest.paymentType,
    remarks: bookingRequest.remarks,
    itinerary,
  };
}

export function containsAdditionalDropOff(booking: Booking) {
  return (booking.itinerary || []).length > 2;
}

export function canDestinationBeChanged(state: number) {
  return state === BOOKING_STATE_DROPPING_OFF;
}



/** WEBPACK FOOTER **
 ** ./src/js/utils/booking-utils.js
 **/